import { render } from "./S3.vue?vue&type=template&id=898628a8"
import script from "./S3.vue?vue&type=script&lang=js"
export * from "./S3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__